import { useEffect, useState } from 'react';

/**
 * Returns the pixel height that the virtual keyboard has pushed the visual
 * viewport up from the layout viewport bottom.
 *
 * When the keyboard is closed the offset is 0.
 * When the keyboard is open the offset equals the keyboard height in px.
 *
 * Uses window.visualViewport which is well-supported on iOS Safari 13+ and
 * Android Chrome 62+. Falls back to 0 on unsupported environments.
 */
export default function useMobileKeyboardOffset() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;

    const update = () => {
      // layoutViewport height ≈ window.innerHeight (excludes address bar shrink on scroll)
      // visualViewport height shrinks when the keyboard opens
      const keyboardHeight = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setOffset(keyboardHeight);
    };

    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return offset;
}
